<template>
    <div id="full-archive-category">
        <v-container fluid v-if="single" class="px-0">
            <v-row no-gutters>
                <v-col cols="12" v-for="(cat,index) in single" :key="cat.category.slug+index">
                    <hr class="linea z-index-0 w-100 mx-auto">
                   <v-row no-gutters align="center" class="border-top-0">
                    <v-col cols="2" md="2" class="text-center" >
                        <v-img
                            v-if="cat.category.logo_white"
                            :lazy-src="cat.category.logo_white.sizes.thumbnail"
                            lazy
                            width="50"
                            :src="cat.category.logo_white.sizes.full"
                            contain
                            :alt="cat.category.logo_white.title+' - '+cat.category.logo_white.description"
                            class="mx-auto bg-black z-index-3"
                        ></v-img>
                    </v-col>
                    <v-col cols="10" md="6" > 
                        <h2>
                            <span class="bg-black z-index-3 position-relative px-2">
                                {{ cat.category.title }}
                            </span>
                        </h2>
                    </v-col>
                    <v-col cols="12" md="4" class="text-end pe-4 "> 
                        <v-btn :to="getSearchRoute(cat.category)" color="white" variant="text" class="btn-primelinks rounded-0 bg-black z-index-3">
                            <span class="text-underline">{{t('commons.check-aviability')}}</span>
                            <v-icon class="ms-3">mdi-chevron-right</v-icon>
                        </v-btn>
                    </v-col>

                    <v-col cols="12">
                        <page-slider :items="cat.pages"></page-slider>
                    </v-col>

                    <v-col cols="12" class="my-5">
                      
                    </v-col>

                   </v-row>
                </v-col>
            </v-row>
        </v-container>
        <v-container v-if="loading">
            <v-row>
                <v-col cols="12" class="text-center my-5">
                    <v-progress-circular :indeterminate="loading" :size="75" :width="8">
                    </v-progress-circular>
                    <br>
                    {{ t('commons.loading') }}
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script setup>

import PageSlider from './subComponents/PageSlider.vue'
import { useLocale } from 'vuetify'
const { t } = useLocale()

</script>

<script>
import {mapGetters} from "vuex";

export default {
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
   
    computed: {
        ...mapGetters({
            loading: 'loading/loading',
            page: 'pages/single',
            adminPage: 'AdminPages/single',
            single: 'categories/single',
        }),
    },
    data: () => ({
        current_page: null,
    }),
    unmounted(){
        this.$store.dispatch('categories/resetSingle', null );
    },
    mounted(){
        if(!this.data.list){
            let cat_slug = null;
            this.current_page = (this.page) ? this.page : this.adminPage;
            if(this.data.category_type == 'car_brand'){
                this.data.category_type = "brand";
            }
            if(this.data.category_type == 'car_type'){
                this.data.category_type = "type";
            }
            if(this.data.category_type){
                if(this.current_page[this.data.category_type]){
                    cat_slug = this.current_page[this.data.category_type].slug
                    this.getCategory(cat_slug);
                }
            }

        }else{
            this.setCategory(this.data.list);
        }

    },
    methods:{
        /**
         * @param {array} list - an array of categories
         * set a category list as single category for the store
         * @return {void}
         */
        setCategory(list){
            this.$store.dispatch('categories/setAsSingle',list );
        },
        async getCategory(slug){
            await this.$store.dispatch('categories/getSingle',slug );
        },
        getSearchRoute(cat){
            var car_brand = null;
            var car_type = null;
            this.current_page = (this.page) ? this.page : this.adminPage;
            
            if(this.current_page.brand){
                car_brand = this.current_page.brand.drive_id
            }else{
                car_brand = cat.drive_id
            }

            if(this.current_page.type){
                car_type = this.current_page.type.drive_id
            }else{
                car_type = cat.drive_id
            }

            return "/search?car_type="+car_type+"&car_brand="+car_brand;

        }
    }
}
</script>


<style scoped>

.black-and-white{
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}

.inverted{
    -webkit-filter:invert(100%);
    filter: invert(100%);
}

.border-top-2{
    border-top: 0.32px solid #FFF;
}

.linea{
    position: relative;
    top: 1.62rem;
}

</style>